export default __webpack_public_path__ + "static/media/autopflege-logo.18a1981b.png";